import pic_1 from '../Assets/Pics/pic_1.jpg';
import pic_2 from '../Assets/Pics/pic_2.JPG';
import pic_3 from '../Assets/Pics/pic_3.JPG';
import pic_4 from '../Assets/Pics/pic_4.JPG';
import pic_5 from '../Assets/Pics/pic_5.JPG';
import pic_6 from '../Assets/Pics/pic_6.JPG';
import pic_7 from '../Assets/Pics/pic_7.JPG';
import pic_8 from '../Assets/Pics/pic_8.jpg';
import pic_9 from '../Assets/Pics/pic_9.jpg';
import pic_10 from '../Assets/Pics/pic_10.jpg';
import pic_11 from '../Assets/Pics/pic_11.jpg';
import pic_12 from '../Assets/Pics/pic_12.jpg';
import cert_2016_1 from '../Assets/Certificates/2016/Certificate_1.jpg';
import cert_2016_2 from '../Assets/Certificates/2016/Certificate_2.jpg';
import cert_2016_3 from '../Assets/Certificates/2016/Certificate_3.jpg';
import cert_2016_4 from '../Assets/Certificates/2016/Certificate_4.jpg';
import cert_2016_5 from '../Assets/Certificates/2016/Certificate_5.jpg';
import cert_2016_6 from '../Assets/Certificates/2016/Certificate_6.jpg';
import cert_2016_7 from '../Assets/Certificates/2016/Certificate_7.jpg';
import cert_2016_8 from '../Assets/Certificates/2016/Certificate_8.jpg';
import cert_2016_9 from '../Assets/Certificates/2016/Certificate_9.jpg';
import cert_2017_1 from '../Assets/Certificates/2017/Certificate_1.jpg';
import cert_2017_2 from '../Assets/Certificates/2017/Certificate_2.jpg';
import cert_2017_3 from '../Assets/Certificates/2017/Certificate_3.jpg';
import cert_2017_4 from '../Assets/Certificates/2017/Certificate_4.jpg';
import cert_2017_5 from '../Assets/Certificates/2017/Certificate_5.jpg';
import cert_2018_1 from '../Assets/Certificates/2018/2018_1.jpg';
import cert_2018_2 from '../Assets/Certificates/2018/2018_2.jpg';
import cert_2018_3 from '../Assets/Certificates/2018/2018_3.jpg';
import cert_2018_4 from '../Assets/Certificates/2018/2018_4.jpg';
import cert_2019_1 from '../Assets/Certificates/2019/2019_1.jpg';
import cert_2019_2 from '../Assets/Certificates/2019/2019_2.jpg';
import cert_2019_3 from '../Assets/Certificates/2019/2019_3.jpg';
import cert_2019_4 from '../Assets/Certificates/2019/2019_4.jpg';
import cert_2020_1 from '../Assets/Certificates/2020/Angular.pdf';
import cert_2020_2 from '../Assets/Certificates/2020/BasicR.pdf';
import cert_2020_3 from '../Assets/Certificates/2020/BlockChain.pdf';
import cert_2020_4 from '../Assets/Certificates/2020/webinar.pdf';
import cert_2020_5 from '../Assets/Certificates/2020/GIC1.pdf';
import cert_2020_6 from '../Assets/Certificates/2020/Jquery.pdf';
import cert_2020_7 from '../Assets/Certificates/2020/NodeJS.pdf';
import cert_2020_8 from '../Assets/Certificates/2020/Python.pdf';
import cert_2020_9 from '../Assets/Certificates/2020/CProgramming.jfif';
import cert_2020_10 from '../Assets/Certificates/2020/Java.jfif';
import cert_2020_11 from '../Assets/Certificates/2020/ReactRedux.jfif';
import cert_2021_1 from '../Assets/Certificates/2021/BEcerti.pdf';
import cert_2021_2 from '../Assets/Certificates/2021/HTML-CSS.jpg';
import cert_2021_3 from '../Assets/Certificates/2021/JavaScript.jpg';
import cert_2021_4 from '../Assets/Certificates/2021/React-Native.jpg';

export const desktop_card = [
  {
    name: 'Yash Datir',
    sub:
      'B.E. Computer from GTU, Ahmedabad. I am from Vadodara, Gujarat and currently in ...; I love Travelling, Eating, Coding and Reading. I have a total work experience of 1.6 years and relevant work experience of 1.3 years as a Fullstack developer with ReactJS with Redux and NodeJS. Also have a decent on experience on ElectronJS, ExpressJS, NextJS, Git(VC), AWS(EC2-C9).',
  },
  [
    {
      header: 'Achievements',
      sub: [
        'Completed course of RedHat @ IIHT, Baroda',
        'Completed course of C/C++, Java @ IIHT, Baroda',
        'Best Rookie Award @ Robocon 2018',
        'Completed Internship @ IOCL-GR',
        'Completed Internship @ Ruby Infotech',
        'Completed B.E. Computer Engineeering',
        'Completed Internship @ Xelpmoc Design and Tech',
        'Completion of 1 Year @ Xelpmoc Design and Tech',
      ],
    },
    {
      header: 'Projects',
      sub: [
        'BMS with HVAC(IoT) @ NTC',
        'Industrial Software Soln @ NTC',
        'Final Year Project @ NTC',
        'E Vendor System @ IOCL',
        'Webhost Console @ Ruby Infotech',
        'Rentickle @ Xelpmoc',
        'Knack @ Xelpmoc',
        'Intranet @ Xelpmoc',
        'Online Acadezy @ Xelpmoc',
        'Assessment @ Xelpmoc',
      ],
    },
  ],
  {
    header: 'Credits',
    sub: ['My Parents and Family', 'My Teachers and Gurus', 'My Friends'],
  },
];

export const desktop_directories = [
  {
    icon: <i className="fi-rr-info"></i>,
    name: 'Information',
    action: 'info',
    data: {
      message: (
        <>
          <h2>Yash Ajay Datir</h2>
          <p align="center" style={{ width: '80%', margin: '1%' }}>
            Hello World! I am Yash Datir. Born{' '}
            <a href="https://maps.google.com">here</a> in August 98. Here I
            display my skills regarding web development. This type of webpage is
            made using pure HTML/CSS and a pinch of React to it for flavouring
          </p>
        </>
      ),
      links: [
        {
          icon: <i className="icon-facebook"></i>,
          name: 'Facebook',
          url: '',
        },
        {
          icon: <i className="icon-instagram"></i>,
          name: 'Instagram',
          url: '',
        },
        {
          icon: <i className="icon-whatsapp"></i>,
          name: 'WhatsApp',
          url: '',
        },
        {
          icon: <i className="icon-linkedin"></i>,
          name: 'LinkedIn',
          url: '',
        },
        {
          icon: <i className="icon-youtube"></i>,
          name: 'Youtube',
          url: '',
        },
        {
          icon: <i className="icon-twitter"></i>,
          name: 'Twitter',
          url: '',
        },
        {
          icon: <i className="icon-paypal"></i>,
          name: 'Paypal',
          url: '',
        },
        {
          icon: <i className="icon-reddit icon-image"></i>,
          name: 'Reddit',
          url: '',
        },
      ],
    },
  },
  {
    icon: <i className="fi-rr-folder"></i>,
    name: 'Images',
    action: 'carousel',
    data: [
      { name: 'yash_1', type: 'image', url: pic_1 },
      { name: 'yash_2', type: 'image', url: pic_2 },
      { name: 'yash_3', type: 'image', url: pic_3 },
      { name: 'yash_4', type: 'image', url: pic_4 },
      { name: 'yash_5', type: 'image', url: pic_5 },
      { name: 'yash_6', type: 'image', url: pic_6 },
      { name: 'yash_7', type: 'image', url: pic_7 },
      { name: 'yash_8', type: 'image', url: pic_8 },
      { name: 'yash_9', type: 'image', url: pic_9 },
      { name: 'yash_10', type: 'image', url: pic_10 },
      { name: 'yash_11', type: 'image', url: pic_11 },
      { name: 'yash_12', type: 'image', url: pic_12 },

      // { name: 'yash', type: 'image', url: 'https://placekitten.com/g/300/300' },
      // {
      //   name: 'ajay',
      //   type: 'video',
      //   url:
      //     'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
      // },
      // { name: 'datir', type: 'audio', url: '' },
      // { name: 'text file', type: 'text', url: 'This is a text file' },
      // {
      //   name: 'pdf',
      //   type: 'pdf',
      //   url:
      //     'https://www.india.gov.in/sites/upload_files/npi/files/coi_part_full.pdf',
      // },
    ],
  },
  {
    icon: <i className="fi-rr-folder"></i>,
    name: 'Certificates',
    action: 'carousel',
    data: [
      { name: '2016_1', type: 'image', url: cert_2016_1 },
      { name: '2016_2', type: 'image', url: cert_2016_2 },
      { name: '2016_3', type: 'image', url: cert_2016_3 },
      { name: '2016_4', type: 'image', url: cert_2016_4 },
      { name: '2016_5', type: 'image', url: cert_2016_5 },
      { name: '2016_6', type: 'image', url: cert_2016_6 },
      { name: '2016_7', type: 'image', url: cert_2016_7 },
      { name: '2016_8', type: 'image', url: cert_2016_8 },
      { name: '2016_9', type: 'image', url: cert_2016_9 },
      { name: '2017_1', type: 'image', url: cert_2017_1 },
      { name: '2017_2', type: 'image', url: cert_2017_2 },
      { name: '2017_3', type: 'image', url: cert_2017_3 },
      { name: '2017_4', type: 'image', url: cert_2017_4 },
      { name: '2017_5', type: 'image', url: cert_2017_5 },
      { name: '2018_1', type: 'image', url: cert_2018_1 },
      { name: '2018_2', type: 'image', url: cert_2018_2 },
      { name: '2018_3', type: 'image', url: cert_2018_3 },
      { name: '2018_4', type: 'image', url: cert_2018_4 },
      { name: '2019_1', type: 'image', url: cert_2019_1 },
      { name: '2019_2', type: 'image', url: cert_2019_2 },
      { name: '2019_3', type: 'image', url: cert_2019_3 },
      { name: '2019_4', type: 'image', url: cert_2019_4 },
      { name: '2020_1', type: 'pdf', url: cert_2020_1 },
      { name: '2020_2', type: 'pdf', url: cert_2020_2 },
      { name: '2020_3', type: 'pdf', url: cert_2020_3 },
      { name: '2020_4', type: 'pdf', url: cert_2020_4 },
      { name: '2020_5', type: 'pdf', url: cert_2020_5 },
      { name: '2020_6', type: 'pdf', url: cert_2020_6 },
      { name: '2020_7', type: 'pdf', url: cert_2020_7 },
      { name: '2020_8', type: 'pdf', url: cert_2020_8 },
      { name: '2020_9', type: 'image', url: cert_2020_9 },
      { name: '2020_10', type: 'image', url: cert_2020_10 },
      { name: '2020_11', type: 'image', url: cert_2020_11 },
      { name: '2021_1', type: 'pdf', url: cert_2021_1 },
      { name: '2021_2', type: 'image', url: cert_2021_2 },
      { name: '2021_3', type: 'image', url: cert_2021_3 },
      { name: '2021_4', type: 'image', url: cert_2021_4 },
    ],
  },
  {
    icon: <i className="fi-rr-ftp"></i>,
    name: 'My Projects',
    action: 'href',
    data:
      'https://drive.google.com/drive/folders/1MCvUnsrvFi7Nk4ovsjSQUa7qOhgYGlrI?usp=sharing',
  },
  {
    icon: <i className="fi-rr-ftp"></i>,
    name: 'My Git',
    action: 'href',
    data: 'https://github.com/yashdatir/',
  },
];

export const date_formats = ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', 'DD-MM'];
export const time_formats = ['hh:mm A', 'hh mm', 'hh:mm:ss'];
export const commands_list = {
  list: 'ls',
  date: 'date',
  ls_cmd: 'ls-cmd',
  exit: 'exit',
  js_eval: 'eval',
  clear: 'clear',
  cd: 'cd',
  history: 'history',
  history_clear: 'history-c',
  echo: 'echo',
};
